// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__2cW5N","filesListContainer":"PosDisputesFiles_filesListContainer__17qJl","filesButton":"PosDisputesFiles_filesButton__zITuW"};